module.exports = __webpack_public_path__ + "static/img/3.7ab99db2.jpg";